module.exports = __webpack_public_path__ + "img/card4.deacf76a.svg";